import React from "react";
import {FormModalProps} from "../../../../utils/useFormModal";
import {Form, Modal} from "antd";
import Select from "../../../../components/Select";

function CompanyModal(props: FormModalProps) {
    const {form, ...otherProps} = props
    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item rules={[{required: true}]} label={'公司'} name={'companyIds'}>
                    <Select url={'/company/dict/'} getData={data => data.data} textField={'name'} valueField={'id'}
                            mode={"multiple"}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default CompanyModal
